import React from "react";
import { Listing, ListItem } from "../../../../widget/common/ui/Listing";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { useSelector } from "react-redux";
import { RootState } from "../../../../libraries/state_reducers/store";
import { useDispatch } from "react-redux";
import { mediaDeleteChooseAction } from "../../../../libraries/state_reducers/chats/ChatsReducer";
import { removeModal } from "../../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../../const/ModalKeys";

const ConversationMediaDeleteConfirmAlert = () => {
  const dispatch = useDispatch();

  const mediaDeleteEveryoneSelector = useSelector(
    (state: RootState) => state.chats.mediaDeleteEveryone
  );

  const handleDelete = (action: "0" | "1") => {
    dispatch(mediaDeleteChooseAction(action));
    dispatch(removeModal(ModalKeys.chat_delete_message_media));
    dispatch(removeModal(ModalKeys.chat_media));
    window.history.replaceState(null, "", window.location.pathname);
  };

  return (
    <Listing>
      <ListItem>
        <div role="button" onClick={() => handleDelete("0")}>
          {AppTranslation.text("delete_for_me")}
        </div>
      </ListItem>
      {mediaDeleteEveryoneSelector != null &&
        mediaDeleteEveryoneSelector?.isEveryone && (
          <ListItem>
            <div role="button" onClick={() => handleDelete("1")}>
              {AppTranslation.text("delete_for_everyone")}
            </div>
          </ListItem>
        )}
    </Listing>
  );
};

export default ConversationMediaDeleteConfirmAlert;
